import {handleGqlResponseBody} from '@/utils/apollo.util';
import {GET_ORDER_ITEMS_PAGINATED_QUERY, GET_ORDER_PAGINATED_QUERY, GET_ORDER_PAYMENTS_PAGINATED_QUERY} from '@/graphql/order/order.query';
import {toSnakeCase} from '@/utils/string.util';

const order = {
	actions: {
		async getOrdersPaginatedQuery({commit}, {skip, take, orderBy, query, status}) {
			orderBy = orderBy.map((o) => ({
				...o,
				fieldName: toSnakeCase(o.fieldName),
			}));
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_ORDER_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						query,
						status,
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getOrderPaymentsPaginatedQuery({commit}, {skip, take, orderBy, orderId}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_ORDER_PAYMENTS_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						orderId
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
		async getOrderItemsPaginatedQuery({commit}, {skip, take, orderBy, orderId}) {
			return await handleGqlResponseBody(({query: queryMethod}) => {
				return queryMethod({
					query: GET_ORDER_ITEMS_PAGINATED_QUERY,
					variables: {
						skip,
						take,
						orderBy,
						orderId
					},
					fetchPolicy: 'no-cache'
				});
			});
		},
	}
};

export default order;
